"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectMap = void 0;
function objectMap(o, f) {
    // @ts-expect-error : ts can't keep up
    return Object.fromEntries(Object.entries(o).map(([k, v]) => [k, f(v, k, o)]));
}
exports.objectMap = objectMap;
//# sourceMappingURL=objectMap.js.map